// Barra di robustezza password: 4 livelli (Debole → Forte) con suggerimenti.
export const scorePassword = (pw = "") => {
  if (!pw) return 0;
  let s = 0;
  if (pw.length >= 8) s += 1;
  if (pw.length >= 12) s += 1;
  if (/[a-z]/.test(pw) && /[A-Z]/.test(pw)) s += 1;
  if (/\d/.test(pw)) s += 1;
  if (/[^A-Za-z0-9]/.test(pw)) s += 1;
  // normalizza su 0..4
  return Math.min(4, s);
};

const LEVELS = [
  { label: "Molto debole", cls: "bg-red-500", text: "text-red-600" },
  { label: "Debole", cls: "bg-orange-500", text: "text-orange-600" },
  { label: "Discreta", cls: "bg-amber-500", text: "text-amber-600" },
  { label: "Buona", cls: "bg-lime-500", text: "text-lime-600" },
  { label: "Forte", cls: "bg-emerald-500", text: "text-emerald-600" },
];

export const PasswordStrength = ({ password = "", className = "" }) => {
  if (!password) return null;
  const score = scorePassword(password);
  const lvl = LEVELS[score];
  const filled = Math.max(1, score); // almeno 1 barretta quando c'è testo
  return (
    <div className={`mt-2 ${className}`} data-testid="password-strength">
      <div className="flex items-center gap-1" aria-hidden="true">
        {[0, 1, 2, 3].map((i) => (
          <span
            key={i}
            className={`h-1.5 flex-1 rounded-full transition-colors duration-200 ${i < filled ? lvl.cls : "bg-border"}`}
          />
        ))}
      </div>
      <div className={`mt-1 text-[11px] font-medium ${lvl.text}`} data-testid="password-strength-label">
        Sicurezza password: {lvl.label}
      </div>
    </div>
  );
};

export default PasswordStrength;
